import React, { useEffect, useState } from 'react';
import Alert from "@material-ui/lab/Alert";
import { useStyles } from "./style";
import { Snackbar } from '@material-ui/core';

function CreateUpdateUser(props) {  
    const vertical = 'bottom';
    const horizontal = 'center';
    const classes = useStyles(),
        [openAlertaGeneral, setOpenAlertaGeneral] = useState(false);
    const handleCloseAlertaGeneral = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenAlertaGeneral(false);
        return props.funcionObtenerEstadoEnElPadron(false);
    };

    useEffect(() => {
        if(
            //estos codigos no se permiten poder empadronar ni actualizar datos
            props.data?.estadoPadron?.codStatus === 0 || props.data?.estadoPadron?.codStatus === 1 || props.data?.estadoPadron?.codStatus === 2 ||
            props.data?.estadoPadron?.codStatus === 4 || props.data?.estadoPadron?.codStatus === 6 || props.data?.estadoPadron?.codStatus === 10 ||
            props.data?.estadoPadron?.codStatus === 12 || props.data?.estadoPadron?.codStatus === 13 || props.data?.estadoPadron?.codStatus === 14 ||
            props.data?.estadoPadron?.codStatus === 15
        ){
            setOpenAlertaGeneral(true);
            return props.funcionObtenerEstadoEnElPadron(true)
        }
        else return props.funcionObtenerEstadoEnElPadron(false)
    },[])

    return (
        <div className={classes.root}>
            {
                (openAlertaGeneral) ? (
                    <Snackbar open={openAlertaGeneral} onClose={handleCloseAlertaGeneral} anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
                        <Alert variant="filled" severity="warning" elevation={6} onClose={handleCloseAlertaGeneral} style={{color: 'black'}}>
                            El ciudadano(a) "{props.data?.nombreCompleto}" con DPI "{props.data?.dpi}" y número de boleta "{props.data?.nroBoleta}" se encuentra en estado "{props.data?.estadoPadron?.nombreStatus}" dentro del padrón.
                        </Alert>
                    </Snackbar>
                ): ''
            }
        </div>
    );
}

export default CreateUpdateUser;